// Lyve DMS reports data client.
//
// The touring catalogue, box scores, artist aggregates and show records are
// served publicly by the Lyve DMS gateway under /dms/* — no auth key is
// required for these read endpoints. The base URL is configured via
// REACT_APP_LYVE_DMS_API_URL (defaults to https://api.lyveaia.com).

const BASE = process.env.REACT_APP_LYVE_DMS_API_URL || 'https://api.lyveaia.com';
const SEATDATA_KEY = process.env.REACT_APP_SEATDATA_API_KEY;

function buildQs(params = {}) {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === '') continue;
    p.set(k, String(v));
  }
  const s = p.toString();
  return s ? `?${s}` : '';
}

async function getJson(path) {
  const headers = { accept: 'application/json' };
  if (SEATDATA_KEY) headers['X-SeatData-Key'] = SEATDATA_KEY;
  const r = await fetch(`${BASE}/dms${path}`, { headers });
  const text = await r.text();
  let json = null;
  try {
    json = JSON.parse(text);
  } catch {
    json = { raw: text };
  }
  if (!r.ok) {
    const err = new Error(json.detail || json.error || json.message || `DMS HTTP ${r.status}`);
    err.status = r.status;
    err.data = json;
    throw err;
  }
  return json;
}

export const dmsService = {
  // Generic accessor: path is the DMS route suffix (e.g. "artists", "shows/aespa…/listings").
  get(path = '', params = {}) {
    const clean = String(path).replace(/^\/+/, '');
    return getJson(`/${clean}${buildQs(params)}`);
  },
  root: () => getJson(''),
  summary: () => getJson('/summary'),
  catalogue: () => getJson('/catalogue'),
  datasets: () => getJson('/datasets'),
  dataset: (id, params = {}) => getJson(`/datasets/${encodeURIComponent(id)}${buildQs(params)}`),
  artists: (params = {}) => getJson(`/artists${buildQs(params)}`),
  artist: (name) => getJson(`/artists/${encodeURIComponent(name)}`),
  shows: () => getJson('/shows'),
  show: (name) => getJson(`/shows/${encodeURIComponent(name)}`),
  showListings: (name) => getJson(`/shows/${encodeURIComponent(name)}/listings`),
};

export default dmsService;
